// DO NOT EDIT -- generated from fs/services/alexa/funnelmetrics_service.proto

import { RequestAnalyticsAttributes } from './request_analytics.proto';
import { QueryCacheOptions, SampleOptions, SampleResults } from './search_service_types.proto';
import * as funnelmetrics from '../../api/metrics/funnelmetrics';
import * as protobuf from '../../../google/protobuf';
import * as search from '../../api/search';

export namespace FunnelMetricsServicePublic {

  export const ComputeFunnelMetricsEndpoint = "/grpc/alexa.FunnelMetricsServicePublic/ComputeFunnelMetrics";
  /**
   * ComputeFunnelMetrics takes a metric and computes aggregate statistics on the funnel
   * in the supplied time range and time interval.
   * Additionally callers can supply a segment definition to filter
   * events for a group of individuals.
   * Additionally callers can provide a dimension to group results.
   * Additionally callers can provide a time interval to time-bucket results
   * Expected error codes:
   * Unimplemented: for certain configurations of the request that have not been implemented.
   * NotFound: If Org is not found.
   * InvalidArgument: If FunnelMetric or TimeRange are missing or invalid.
   */
  export function ComputeFunnelMetrics(sender: (req: ComputeFunnelMetricsRequest, endpoint: string) => Promise<ComputeFunnelMetricsResponse>, req: ComputeFunnelMetricsRequest): { promise: () => Promise<ComputeFunnelMetricsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeFunnelMetricsEndpoint),
      endpoint: ComputeFunnelMetricsEndpoint
    };
  }
}

export interface ComputeFunnelMetricsCacheKey {
  request: ComputeFunnelMetricsRequest | null;
  searchCacheKey: search.CacheKey | null;
}

export interface ComputeFunnelMetricsRequest {
  /** The Org ID for which the data will be computed. */
  orgId: string;
  /** Defines the computation. */
  computation: funnelmetrics.Computation | null;
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
  /**
   * CacheOptions is options for the query cache. Default will be
   * provided by the application if any fields are omitted.
   * Defaults are set based on the time interval of the computation.
   */
  cacheOptions: QueryCacheOptions | null;
  /**
   * If set, opts in to sampling.
   * Results will be extrapolated based on sample percent.
   */
  sampleOptions: SampleOptions | null;
  /** Contains the associated analytics attributes with the compute funnel metrics request */
  requestAnalytics: RequestAnalyticsAttributes | null;
}

export interface ComputeFunnelMetricsResponse {
  /** Data tables for each step of the funnel */
  data: funnelmetrics.FunnelDataTables | null;
  /** ComputedAt determines when the data was computed. */
  computedAt: protobuf.timestamp | null;
  /** If non empty, a reference id for which the background computation can be managed. */
  backgroundRefId: string;
  /**
   * If set, indicates sample result details.
   * If unset or underlying percent is 100, response contains full resolution data with no options to follow up iteratively.
   */
  sampleResults: SampleResults | null;
}
